export const selectIsBoardsLoading = state => state.boards.isLoading;
export const selectAllBoardsList = state => state.boards.allBoards;
export const selectShownBoard = state => state.boards.shownBoard;
export const getFilter = state => state.filter.filter;
